import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const GetMultilingualCodesSchema = z.object({
  code: z.union([z.string(), z.array(z.string())]),
  search: z.coerce.string().optional(),
  locale: z.string(),
  system: z.union([z.string(), z.array(z.string())]).optional(),
});

export const MultilingualCodesResultSchema = z.object({
  codes: z.array(
    z.object({
      value: z.string(),
      label: z.string(),
    }),
  ),
});

export const GetDeclarationsCustomsCodesSchema = z.object({
  families: z.array(z.string()),
  values: z.array(z.string()),
  system: z.union([z.string(), z.array(z.string())]).optional(),
  locale: z.string(),
});

export const DeclarationsCustomsCodesResultSchema = z.object({
  codes: z.array(
    z.object({
      family: z.string(),
      values: z.array(
        z.object({
          value: z.string(),
          label: z.string(),
        }),
      ),
    }),
  ),
});

export const multilingualCodeContract = c.router({
  getCodes: {
    method: 'POST',
    path: '/external-api/multilingual-codes',
    body: GetMultilingualCodesSchema,
    responses: { 200: MultilingualCodesResultSchema },
  },
  getDeclarationsCustomsCodes: {
    method: 'POST',
    path: '/external-api/multilingual-codes/declarations-customs-codes',
    body: GetDeclarationsCustomsCodesSchema,
    responses: { 200: DeclarationsCustomsCodesResultSchema },
  },
});
